// Promise Polyfill
import 'es6-promise/auto';
import { ApolloProvider } from '@apollo/client';
import { Notification } from '@arcadiapower/shrike';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { LDClient, LDProvider, QueryParamsProvider, LocalizeProvider } from '~/providers';
import { initializeTracking } from '~/utils/tracking';
import { apolloClient } from './apollo-client';
import { App, Token } from './app';
import { GlobalStyles, theme } from './styles';
import '@arcadiapower/shrike/dist/shrike.css';

initializeTracking();

ReactDOM.render(
  <LDProvider client={LDClient}>
    <ThemeProvider theme={theme}>
      <ApolloProvider client={apolloClient}>
        <BrowserRouter>
          <Token>
            <QueryParamsProvider>
              <Notification.Provider>
                <LocalizeProvider>
                  <App />
                </LocalizeProvider>
                <GlobalStyles />
              </Notification.Provider>
            </QueryParamsProvider>
          </Token>
        </BrowserRouter>
      </ApolloProvider>
    </ThemeProvider>
  </LDProvider>,
  document.getElementById('app'),
);
